import { ISnotrRoute } from '..';

export default [
  {
    path: '/application-settings',
    meta: {
      title: 'TabTitle.applicationSettings',
      applicationMode: 'PaycheckMode',
    },
    component: () => import('@/pages/ApplicationSettings/main.vue'),
    children: [
      {
        path: '',
        name: 'ApplicationSettings',
        component: () => import('@/pages/ApplicationSettings/application-settings.vue'),
      },
      {
        path: 'paycheck-template',
        component: () => import('@/pages/ApplicationSettings/paycheck-template.vue'),
      },
    ],
  },
] as ISnotrRoute[];
